
import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

const items = [
  {
    q: "What does the audit cover?",
    a: "A comprehensive assessment across 20 points including Mental Energy, Sleep, Movement, Stress, Nutrition, and Resilience. Each category is scored to build a 360-degree performance profile.",
  },
  {
    q: "How is the score calculated?",
    a: "Responses are weighted and normalised to a 0–100 scale. The total score determines the performance tier: 0–25 (Critical), 26–50 (Exposed), 51–75 (Performing), and 76–100 (Elite).",
  },
  {
    q: "Data Security: How is my member or employee data protected?",
    a: "We strictly adhere to UK GDPR standards. Data is stored on encrypted, UK-aligned infrastructure with access gated by JWT-authenticated cookies. For Business Licence holders, individual identifiers are never exposed to HR; only anonymised departmental aggregates are visible. We sign DPAs on request and never sell or rent personal data.",
  },
  {
    q: "ROI for Gyms: How does Fitest help retention and revenue?",
    a: "Gym Licence holders drive ROI through three levers: identifying at-risk members to reduce churn, surfacing high-intent leads who actively request assistance, and deploying automated 30-day follow-up campaigns. Saving just 2–3 members per month typically covers the entire annual licence cost.",
  },
  {
    q: "Affiliate Payouts: How do I get paid?",
    a: "Affiliates earn a 20% recurring commission on every referred licence. Earnings accrue monthly and are processed on the 1st of every month via Stripe Express once your balance exceeds £0. You will complete a one-time Stripe onboarding to verify bank details for secure transfers.",
  },
  {
    q: "Affiliate Earnings: Is there a limit to how much I can earn?",
    a: "No. Your earnings are uncapped and recurring. As long as the licences you refer remain active, you continue to receive your 20% share every month. You do not need an active Fitest licence to participate in the affiliate program.",
  },
  {
    q: "Custom Slugs: Can I brand my audit URL?",
    a: "Yes. You can generate a custom slug (e.g., fitest.co.uk/audit/city-gym) within your dashboard. Slugs must be unique, at least 3 characters long, and are permanently reserved to your account once created.",
  },
  {
    q: "Can my members get a copy of their report?",
    a: "Yes. Upon completion, members can immediately download a branded 3-page PDF report featuring their score, category breakdown, and a tailored 30-day action plan.",
  },
  {
    q: "Which licence should I choose?",
    a: "The Gym Licence (£149/year) is designed for studios focused on member retention and lead generation. The Business Licence (£249/year) is built for HR teams requiring departmental benchmarking and anonymised workforce performance audits.",
  },
  {
    q: "How is my account set up?",
    a: "Once your subscription is active, our team configures your unique audit environment within 1–2 business days. This manual step ensures full GDPR compliance and secure data partitioning for your organization.",
  },
  {
    q: "How quickly can we go live?",
    a: "After the initial 1–2 day setup, your environment is live instantly. You can deploy your custom audit URL as soon as you receive your dashboard activation email.",
  },
  {
    q: "Do you offer enterprise SSO and DPA?",
    a: "Yes. Both Enterprise SSO and formal Data Processing Agreements (DPA) are available for Business Licence holders. Please contact our support team to initiate the setup.",
  },
];

export default function FAQ() {
  return (
    <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20" data-testid="faq-page">
      <span className="eyebrow">Help Center</span>
      <h1 className="font-display tracking-tighter text-5xl mt-4">Frequently asked questions</h1>
      <p className="text-slate-300 mt-4">Professional diagnostics for elite fitness operators and enterprise HR teams.</p>

      <Accordion type="single" collapsible className="mt-10">
        {items.map((it, i) => (
          <AccordionItem key={i} value={`item-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
            <AccordionTrigger className="text-left font-display text-lg hover:no-underline">
              {it.q}
            </AccordionTrigger>
            <AccordionContent className="text-slate-400 leading-relaxed">
              {it.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
